var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuperiorityBgMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 235,
    viewBox: "0 0 343 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.035 23.0801L15.0406 82.6329C5.95312 86.2896 0 95.1022 0 104.898V210.667C0 223.922 10.7452 234.667 24 234.667H319C332.255 234.667 343 223.922 343 210.667V104.861C343 95.0838 337.069 86.284 328.006 82.615L181 23.0991C175.24 20.767 168.8 20.7602 163.035 23.0801Z",
    fill: "url(#paint0_linear_4126_8236)",
    fillOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M162.653 12.6888L14.6601 75.2109C5.7747 78.9646 0 87.6731 0 97.3189V210.666C0 223.921 10.7452 234.666 24 234.666H319C332.255 234.666 343 223.921 343 210.666V97.2812C343 87.6545 337.248 78.9593 328.388 75.1936L181.381 12.7092C175.399 10.1665 168.641 10.1591 162.653 12.6888Z",
    fill: "url(#paint1_linear_4126_8236)",
    fillOpacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M162.279 2.31112L14.2877 67.8025C5.60178 71.6463 0 80.2511 0 89.7495V210.667C0 223.922 10.7452 234.667 24 234.667H319C332.255 234.667 343 223.922 343 210.667V89.711C343 80.2322 337.421 71.6413 328.762 67.7859L181.753 2.33307C175.557 -0.425851 168.482 -0.433828 162.279 2.31112Z",
    fill: "url(#paint2_linear_4126_8236)",
    fillOpacity: 0.05
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4126_8236",
    x1: 171.5,
    y1: 19.4639,
    x2: 171.5,
    y2: 234.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7FFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF66",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4126_8236",
    x1: 171.5,
    y1: 8.73096,
    x2: 171.5,
    y2: 234.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7FFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF66",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4126_8236",
    x1: 171.5,
    y1: -2,
    x2: 171.5,
    y2: 234.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7FFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF66",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperiorityBgMobile);
export default __webpack_public_path__ + "static/media/superiority-bg-mobile.a8c82cb1715f011c863c4f1686e7485b.svg";
export { ForwardRef as ReactComponent };